/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Vibebids_Current_BidInputs */

const en_directory_vibebids_current_bid = /** @type {(inputs: Directory_Vibebids_Current_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`current bid`)
};

const zh_directory_vibebids_current_bid = /** @type {(inputs: Directory_Vibebids_Current_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前出价`)
};

/**
* | output |
* | --- |
* | "current bid" |
*
* @param {Directory_Vibebids_Current_BidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_current_bid = /** @type {((inputs?: Directory_Vibebids_Current_BidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Current_BidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_current_bid(inputs)
	return zh_directory_vibebids_current_bid(inputs)
});
export { directory_vibebids_current_bid as "directory.vibebids.current_bid" }